import React from "react";

/**
 * HistorySection proporciona un relato de la trayectoria pasada de
 * MUGIN.  Está preparado como un componente de clase para que en
 * el futuro pueda cargar su contenido de manera asíncrona desde un
 * servicio web.  Por ahora se inicializa con un texto inventado que
 * narra parte de la historia del grupo.
 */
class HistorySection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content:
        "En construcción.",
    };
  }
  render() {
    return (
      <section className="history-section my-5">
        <h2 className="section-title">Y antes qué</h2>
        <p>{this.state.content}</p>
      </section>
    );
  }
}

export default HistorySection;